import { wait } from "../utils";

export const trackEvent = async (
  eventName: string,
  eventProperties?: Record<string, any>
) => {
  const heap = await getHeapInstance();

  if (heap) {
    heap.track(eventName, eventProperties);
  }
};

/**
 * Poll the window for an instance of Heap, returning it when it's found.
 *
 * Necessary because Heap loads async and is only defined once the user accepts
 * cookie consent.
 *
 * @param attempt The current polling attempt
 * @param maxAttempts How many attempts to get Heap before giving up
 * @param interval How long to wait between checking for Heap, in milliseconds
 */
const getHeapInstance = async (
  attempt = 1,
  maxAttempts = 5,
  interval = 200
): Promise<Window["heap"] | null> => {
  if (window.heap?.track) {
    return window.heap ?? null;
  }
  if (attempt > maxAttempts) {
    return null;
  }
  return wait(interval).then(() =>
    getHeapInstance(attempt + 1, maxAttempts, interval)
  );
};
